<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col cols="4" />
    </v-row>
    <v-card-widget title="Dashboard">
      <div slot="widget-content">
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardMonitoramentoPerfil',

  components: { VCardWidget, AppTimeline },

  data() {
    return {
      timelineItens: [
        {
          visibilidade: true,
          titulo: 'Filtros de Busca',
          textos: [
            'Como Gestor você pode realizar buscas com os filtros do módulo perfil.',
          ],
          icone: 'person_search',
          link: '/monitoramento/perfil/filtro',
        },
        {
          visibilidade: true,
          titulo: 'Relatórios Gerais',
          textos: [
            'Como Gestor você pode analisar os dados cadastrados no módulo perfil.',
          ],
          icone: 'insert_chart',
          link: '/monitoramento/perfil/relatorio',
        },
      ],
    };
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
    }),
  },

  created() {
    if (!this.comissao && !this.chefia && !this.substituicaoChefia) {
      this.$router.push('/403');
    }
  },
};
</script>
